/** Map Firebase Auth error codes to friendly, actionable messages. */
import { CONTACT_EMAIL } from './contact';

const MESSAGES: Record<string, string> = {
  // Modern SDKs collapse wrong-password/no-user into invalid-credential
  // (email-enumeration protection) — keep the legacy codes too.
  'auth/invalid-credential': "That email and password don't match. Try again or reset your password.",
  'auth/wrong-password': "That email and password don't match. Try again or reset your password.",
  'auth/user-not-found': 'No account found with that email. Try signing up instead.',
  'auth/email-already-in-use': 'An account with this email already exists. Try logging in instead.',
  'auth/invalid-email': "That doesn't look like a valid email address.",
  'auth/weak-password': 'Please use a stronger password — at least 8 characters.',
  'auth/missing-password': 'Please enter your password.',
  // A provider (e.g. Google) that isn't enabled in the Firebase project.
  'auth/operation-not-allowed':
    "That sign-in method isn't available right now — please use email and password.",
  'auth/too-many-requests': 'Too many attempts. Please wait a minute and try again.',
  'auth/network-request-failed': 'Network error — check your connection and try again.',
  'auth/user-disabled': `This account has been disabled. Contact ${CONTACT_EMAIL} for help.`,
  'auth/popup-blocked': 'Your browser blocked the sign-in popup. Allow popups and try again.',
};

export function mapAuthError(err: unknown): string {
  const code = (err as { code?: string })?.code;
  if (code && MESSAGES[code]) {
    return MESSAGES[code];
  }
  if (err instanceof Error && err.message && !err.message.startsWith('Firebase:')) {
    return err.message;
  }
  return 'Something went wrong signing you in. Please try again.';
}

/** Codes for user-dismissed popups — not real errors, never shown. */
export function isUserCancelled(err: unknown): boolean {
  const code = (err as { code?: string })?.code;
  return code === 'auth/popup-closed-by-user' || code === 'auth/cancelled-popup-request';
}
